import React from 'react';
import { Link } from 'react-router-dom';
import { FUNDING_PIPELINE_STEPS } from '../../utils/funding/constants';
import { useFundingRoutes } from '../../hooks/funding/useFundingRoutes';

const FundingPipelineRibbon = ({ activeStage = 'intake' }) => {
  const routes = useFundingRoutes();

  return (
    <div
      className="mb-6 grid gap-3 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-7"
      aria-label="Funding workflow"
      data-testid="funding-pipeline-ribbon"
    >
      {FUNDING_PIPELINE_STEPS.map((step) => (
        <Link
          key={step.id}
          to={routes.pathFor(step.routeSegment)}
          className="fundgenius-hq-flow-step block no-underline"
          data-active={activeStage === step.id}
          data-testid={`funding-pipeline-step-${step.id}`}
        >
          <strong className="mb-1 block text-sm font-semibold text-[var(--fg-text)]">
            {step.step}. {step.title}
          </strong>
          <span className="text-xs text-[var(--fg-muted)]">{step.description}</span>
        </Link>
      ))}
    </div>
  );
};

export default FundingPipelineRibbon;
